import '.gh{border-left:4px solid var(--gray-200);}.ssr-plugin'
import '.gi{padding-left:1.5rem;}.ssr-plugin'
import '.gj{margin:1rem 0;}.ssr-plugin'
import '.gk{color:var(--gray-700);}.ssr-plugin'
import '.gl{font-style:italic;}.ssr-plugin'
import { Style, styled } from 'inlines'
import { PropsWithChildren } from 'react'

interface BlockQuoteProps extends PropsWithChildren {
  style?: Style
}

export const BlockQuote = ({ children, style }: BlockQuoteProps) => {
  return (
    <styled.blockquote className="gh gi gj gk gl"
      style={{
        ...style,
      }}
    >
      {children}
    </styled.blockquote>
  )
}
